'use strict';

const PRICE_DROP_MODAL_CONFIG = window.clientData.priceDropModalConfig || {
    sessionVar: 'priceDropUserSegment',
    pageLoadModalDelay: 7000
};
const PRICE_DROP_USER_SEGMENTS = {
    urgency: 'Urgency',
    membership: 'Membership',
    repurchase: 'Repurchase'
};

/**
 * Shows the Price Drop Modal with the given content.
 * @param {string} modalContent The content of the modal
 */
function showPriceDropModal(modalContent) {
    if (modalContent) {
        $.modal({
            title: 'Price Just Dropped',
            content: modalContent,
            customClasses: 'modal-positioned price-drop-modal',
            modalSizeClass: 'modal-fluid',
            backdrop: false,
            enableLayeredDrawers: true // omits the `tabindex="-1"` which breaks interacting with other modals/drawers
        }).one('shown.bs.modal', function () {
            $('body').removeClass('modal-open').css('padding-right', '');
        });
    }
}

/**
 * Generates the HTML to put into the Price Drop Modal, depending on the customer group and sale item.
 * @param {string} segment The customer group which determines the content of the modal.
 * @param {JQuery} $saleCard The jQuery object of the sale item we'll display in the modal.
 * @returns {string} The HTML string of the modal content.
 */
function getModalContent(segment, $saleCard) {
    const $productImage = $saleCard.find('.product-image');
    const imageTag = `<img
            src="${$productImage.attr('src')}"
            alt="${$productImage.attr('alt')}"
        />`;
    const productName = `<p>${$saleCard.find('.product-card__name a').text()}</p>`;
    const priceBlock = `<p>${$saleCard.find('.price span').html()}</p>`;
    const salePrice = parseFloat($saleCard.find('.price .discounted').attr('content'));
    const regPrice = parseFloat($saleCard.find('.price .strike-through .value').attr('content'));
    const savings = (regPrice - salePrice).toFixed(2);
    // is the $saleItem in the cart or SFL?
    const saleItemInSFL = !!$saleCard.closest('.js-saveforlater-items').length;

    /**
     * Generates the HTML for the CTA button, depending on if the sale item is in the cart or the SFL list.
     * @param {string} btnText The text to display on the button, if the sale item is in the cart.
     * @returns {string} The HTML string of the CTA.
     */
    function getCTA(btnText) {
        if (saleItemInSFL) {
            const $addToCartBtn = $saleCard.find('.js-saveForLater-add-to-cart');
            return `<button type="button" class="btn btn-primary mt-2 js-saveForLater-add-to-cart"
                    data-pid="${$addToCartBtn.data('pid')}"
                    data-action="${$addToCartBtn.data('action')}"
                >View Price in Bag</a>`;
        }

        return `<a href="${$('.begin-checkout-button .btn-checkout').attr('href')}" class="btn btn-primary mt-2">${btnText}</a>`;
    }

    if (segment === PRICE_DROP_USER_SEGMENTS.membership) {
        return `${imageTag} ${productName} ${priceBlock}
            <p>
                Item recently dropped in price by $${savings}.<br />
                Members get free shipping and rewards for shopping.
                <button class="js-drawer-registration btn btn-link">Join Now</button>
            </p>
            ${getCTA('Continue')}
        `;
    } else if (segment === PRICE_DROP_USER_SEGMENTS.repurchase) {
        const rewards = $saleCard.find('.js-cart-loyalty-actual').text();
        return `${imageTag} ${productName} ${priceBlock}
            <p>
                Item recently dropped in price by $${savings}.<br />
                ${rewards ? `Check out now and earn <strong>${rewards}</strong> in member rewards.` : ''}
            </p>
            ${getCTA('Check Out Now')}
        `;
    }

    // else if (segment === PRICE_DROP_USER_SEGMENTS.urgency || !segment)
    return `${imageTag} ${productName} ${priceBlock}
        <p>This item has recently dropped in price.</p>
        ${getCTA('Hurry and check out')}
    `;
}

/**
 * Selects the last sale item in the cart, or the first sale item in the displayed SFL list.
 * @returns {JQuery} The jQuery object of the chosen sale item. This may be an empty jQuery object if nothing is on sale.
 */
function getSaleItem() {
    // get last sale item in cart
    let $saleCard = $('.cart-products__valid .discounted').closest('.product-card').last();

    if (!$saleCard.length) {
        // nothing is on sale in the cart. check the SFL list
        $saleCard = $('.js-saveforlater-items .discounted').closest('.product-card').first();
    }

    return $saleCard;
}

/**
 * Tries to display the Price Drop Modal if all the conditions are met.
 */
function tryToDisplayModal() {
    const hasOtherModals = !!$('.modal:visible, .drawer:visible').length;

    if (hasOtherModals) {
        $('body').on('hidden.bs.modal.pdm hidden.drawer.pdm', function () { // .one() will handle both events not either event. It doesn't turn off both.
            setTimeout(tryToDisplayModal, 1000);
            $('body').off('hidden.bs.modal.pdm hidden.drawer.pdm'); // turn off both events.
        });
        return;
    }

    const customerGroup = sessionStorage.getItem(PRICE_DROP_MODAL_CONFIG.sessionVar);

    if (customerGroup) {
        const $saleCard = getSaleItem();

        if ($saleCard.length) {
            showPriceDropModal(getModalContent(customerGroup, $saleCard));

            // remove the modal if the cart changes.
            $('body').on('cart:beforeUpdate cart:update', function () {
                $('.price-drop-modal').remove();
            });
        }
    }
}

module.exports = () => {
    if (window.clientData.priceDropModalEnabled) {
        setTimeout(tryToDisplayModal, PRICE_DROP_MODAL_CONFIG.pageLoadModalDelay);
    }
};
